import { createAction } from 'redux-actions';

export const goNextStep = createAction('REGISTER_STEP_NEXT');
export const goPreviousStep = createAction('REGISTER_STEP_PREVIOUS');
export const resetMaster = createAction('REGISTER_RESET_MASTER');
